module.exports = __webpack_public_path__ + "static/media/transfer_job.0a90a1cc.png";